import UserForm from '../_form.js'

import template from './new.pug'

export default Vue.extend({
  template: template(),
  components: {
    UserForm
  },
  data() {
    return {
      ready: false,
      data: {
        customerId: 0
      },
      errors: {},
      customerOptions: []
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('users.admins.form.new.title'))
        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.users.admins.index'), route: {name: 'admins-index'}},
          {label: this.$t('breadcrumbs.users.admins.new'), route: {}}
        ])
      }
    }
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`users.admins.new.${key}`, options)
    },

    create(data) {
      this.errors = {}

      API.users.create(data).then(() => {
        this.$notifications.success(this.$t('users.form.succesfullySave'))
        this.$router.push({name: 'admins-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
